import { render, staticRenderFns } from "./RecommendTitle.vue?vue&type=template&id=87d02f7c&scoped=true"
import script from "./RecommendTitle.vue?vue&type=script&lang=js"
export * from "./RecommendTitle.vue?vue&type=script&lang=js"
import style0 from "./RecommendTitle.vue?vue&type=style&index=0&id=87d02f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.36.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d02f7c",
  null
  
)

export default component.exports